module.exports = __webpack_public_path__ + "static/car-aee517e42f9d33cdf1e64328bac19009.png";